import { GET_OPTA_ESTIMATOR } from '../../constants/actions/policy';

export function getOptaEstimator() {
    return {
        type: GET_OPTA_ESTIMATOR,
    };
}
